import { HydratedCallRecord } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records/v1/call_record.pb';
import { CallIntelTypes, CallIntelUtils } from '@frontend/api-call-intel';
import { PhoneCallsTypes } from '@frontend/api-phone-calls';
import { getDisplayName } from '@frontend/get-display-name';
import { formatPhoneNumber } from '@frontend/phone-numbers';
import { ChipVariants } from '@frontend/design-system';

/**
 * @deprecated - Please use `getFullName` from `@frontend/get-display-name` instead.
 */
export const getFullName = (firstName?: string, lastName?: string, defaultValue = '') => {
  if (firstName || lastName) {
    return `${firstName || ''} ${lastName || ''}`.trim();
  }
  return defaultValue || '';
};

export const getOfficeUser = (callInfo: HydratedCallRecord, showEmptyValue: string) => {
  const { user, status, direction, sipName } = callInfo;
  // if it is an inbound call with status abandoned or missed, then show `showEmptyValue`, otherwise use sipName
  const defaultValue =
    direction === 'inbound' && (status === 'abandoned' || status === 'missed')
      ? showEmptyValue
      : sipName
      ? sipName
      : showEmptyValue;
  const fullName = getFullName(user?.firstName, user?.lastName, defaultValue);
  return fullName;
};

export const getStatusChipColor = (status: PhoneCallsTypes.CallLog['Status']): ChipVariants => {
  switch (status) {
    case 'abandoned':
      return 'warn';
    case 'missed':
      return 'critical';
    case 'answered':
      return 'primary';
    case 'forwarded':
      return 'eggplant';
    default:
      return 'outline';
  }
};

export const getContactInfo = (call: HydratedCallRecord) => {
  const locationId = call?.locationId ?? '';
  const personId = call?.person?.personId ?? '';
  const originalfirstName = call?.person?.firstName ?? '';
  const originalLastName = call?.person?.lastName ?? '';
  const preferredName = call?.person?.preferredName ?? '';
  const {
    firstName,
    lastName,
    fullName: profileName,
  } = getDisplayName({
    firstName: originalfirstName,
    lastName: originalLastName,
    preferredName,
  });

  const number = formatPhoneNumber(call?.direction === 'inbound' ? call?.callerNumber : call?.dialedNumber);
  return { firstName, lastName, locationId, number, personId, profileName };
};

export const processTasks = (tasks: CallIntelTypes.Task[] | undefined, transcript: string): CallIntelTypes.Task[] => {
  if (!tasks) return [];

  return tasks.map((task) => {
    let parsedMetadata;
    let citation = '';
    if (task.metadata) {
      try {
        parsedMetadata = JSON.parse(task.metadata);
        citation = parsedMetadata.citation || '';
      } catch (error) {
        console.error('Error parsing metadata:', error);
      }
    }
    return {
      ...task,
      citation,
      citationTime: CallIntelUtils.findCitationTime(transcript, citation),
    } as CallIntelTypes.Task;
  });
};
